import { createFileRoute } from '@tanstack/react-router';
import { TrackingDashboardPage } from '../../features/tracking';

export const Route = createFileRoute('/portal/tracking/')({ component: TrackingDashboardPage });
